.wrapper {
  display: flex;
  width: 100%;
  padding: 1.5rem 1.5rem 0 1.5rem;
  height: 450px;
  background-image: url("bg-header.png");
  background-size: cover;
}
